function resolveShopifyUrl(src) {
  if (!src) return null;
  if (src.startsWith('http')) return src;
  return 'https://' + window.location.hostname + '/cdn/shop/' + src;
}

function buildSrcset(baseUrl) {
  var clean = baseUrl.split('?')[0];
  return [360, 540, 720, 900, 1080, 1366]
    .map(function(w) { return clean + '?width=' + w + ' ' + w + 'w'; })
    .join(', ');
}

function upgradeHoverImages(root) {
  (root || document).querySelectorAll('[data-depict-product-id]').forEach(function(card) {
    var imageContainer = card.querySelector('.featured-collection__image');
    if (!imageContainer) return;
    if (imageContainer.querySelector('.custom-hover-img-wrap')) return;

    // Läs hover-URL från antingen kortet eller .product-item-hover
    var rawUrl = card.getAttribute('data-depict-hover-image');
    if (!rawUrl || rawUrl.trim() === '') {
      var hoverEl = card.querySelector('[data-depict-hover-image]');
      if (hoverEl) rawUrl = hoverEl.getAttribute('data-depict-hover-image');
    }
    if (!rawUrl || rawUrl.trim() === '') return;

    var hoverUrl = resolveShopifyUrl(rawUrl);
    if (!hoverUrl) return;

    var oldHover = card.querySelector('.product-item-hover[data-bgset]');
    if (oldHover) oldHover.remove();

    var objectContain = imageContainer.querySelector('img[style*="contain"]') !== null;
    var wrap = document.createElement('div');
    wrap.className = 'custom-hover-img-wrap';
    wrap.style.cssText = 'position:absolute;top:0;left:0;bottom:0;right:0;opacity:0;z-index:20;overflow:hidden;pointer-events:none;transition:opacity 0.2s ease-in-out;';

    var img = document.createElement('img');
    img.src = hoverUrl.split('?')[0] + '?width=1366';
    img.srcset = buildSrcset(hoverUrl);
    img.sizes = '(min-width: 1200px) 25vw, (min-width: 768px) 33vw, 50vw';
    img.loading = 'eager';
    img.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;object-fit:' + (objectContain ? 'contain' : 'cover') + ';';
    img.onerror = function() { wrap.remove(); };
    wrap.appendChild(img);
    imageContainer.appendChild(wrap);
  });
}

var observer = new MutationObserver(function(mutations) {
  mutations.forEach(function(m) {
    m.addedNodes.forEach(function(node) {
      if (node.nodeType === 1) upgradeHoverImages(node);
    });
  });
});

observer.observe(document.body, { childList: true, subtree: true });

var attempts = 0;
var interval = setInterval(function() {
  attempts++;
  upgradeHoverImages(document);
  if (document.querySelectorAll('.custom-hover-img-wrap').length > 0 || attempts > 20) {
    clearInterval(interval);
  }
}, 300);

document.addEventListener('mouseover', function(e) {
  var card = e.target.closest('[data-depict-product-id]');
  if (card) {
    var wrap = card.querySelector('.custom-hover-img-wrap');
    if (wrap) wrap.style.opacity = '1';
  }
});

document.addEventListener('mouseout', function(e) {
  var card = e.target.closest('[data-depict-product-id]');
  if (card) {
    var wrap = card.querySelector('.custom-hover-img-wrap');
    if (wrap) wrap.style.opacity = '0';
  }
});